var optionDefault = {
    // minimumResultsForSearch: -1
    allowClear: true,
    placeholder: "...",
}

function resetSelect2(selects){
    $.each(selects, function(i, selectElement){
        $(selectElement).val(false)
        $(selectElement).removeClass('select2-hidden-accessible').next('.select2-container').remove()
        $(selectElement).removeAttr('data-select2-id tabindex aria-hidden')
    })
}

function initBasicSelect2(container, selector, rephresh = true, optionCustom = {minimumResultsForSearch: -1}){
    let options = $.extend( {}, optionDefault, optionCustom )
    let selects = $(container).find(selector)

    if( true == rephresh ){
        resetSelect2(selects)
    }

    $.each(selects, function(i, $selectElement){
        $($selectElement).select2(options)
    })
}

// Select2 with charge data by ajax
function initSelect2BasicAjax(container, selector, tags = false, ajaxUrlDataSelect, optionCustom = {}){
    let $element = $(container).find(selector);
    let optionMethod = {
        tags: tags,
        ajax: {
            url: ajaxUrlDataSelect,
            dataType: 'json',
            processResults: function (data) {
                return {
                    results: data
                }
            }
        },
        createTag: function (params) {
            var term = $.trim(params.term)

            if (term === '' || term.indexOf('@') === -1) {
                return null
            }

            return {
                id: term,
                text: term
            }
        }
    }
    let res_options = $.extend( {}, optionDefault, optionMethod, optionCustom )

    $element.select2(res_options)
}

// Datos necesarios para select2 en cálculos
var providerId = false;
var orderId = false;
function setProviderId( providerIdVal ){
    providerId = providerIdVal;
}

function setOrderId( orderIdVal ){
    orderId = orderIdVal;
}
// Inicializa los select2 que están dentro de los repeaters cuando hay calculos de totales en el back
function initSelect2Totals(container, selector, rephresh = true, ajaxUrlDataSelect, ajaxUrlDataItem, customOptions = {}){
    let selects = $(container).find(selector)

    if( true == rephresh ){
        resetSelect2(selects)
    }

    $.each(selects, function(i, $selectElement){
        let optionsElement = {
            tags: true,
            ajax: {
                url: ajaxUrlDataSelect,
                dataType: 'json',
                data: function (params){
                    var query = {
                        search: params.term,
                        provider_id: providerId,
                        order_id: $($selectElement).find(':selected').data('order-id-sended') ? $($selectElement).find(':selected').data('order-id-sended') : orderId
                    }

                    return query
                },
                processResults: function (data) {
                    data = data.map(function (item) {
                        return {
                            id: item.id,
                            text: item.text,
                            order_id: item.order_id ? item.order_id : false
                        }
                    });

                    return { results: data };
                }
            },
            createTag: function (params) {
                var term = $.trim(params.term)

                if (term === '') {
                    return null
                }

                return {
                    id: term,
                    text: term,
                    newProduct: true
                }
            }
        }

        let options = $.extend( {}, optionDefault, optionsElement, customOptions)

        $($selectElement).select2(options)

    }).on('select2:select', function (e) {
        let $this = $(e.currentTarget)
        let selectedValue = $this.val()
        let $parent = $this.parent().parent()
        let typeContent = $this.data('type-content')
        // Actualilza el order_id para enviarlo en las busquedas
        let paramsData = e.params.data;

        $this.parent().find(':selected').data('order-id-sended', paramsData.order_id)

        if( $.isNumeric( selectedValue ) ){
            $.ajax({
                url: ajaxUrlDataItem,
                data: {
                    'id': selectedValue,
                    'provider_id': providerId,
                    'order_id': paramsData.order_id ? paramsData.order_id : orderId
                },
                success: function(data) {
                    if('discount' == typeContent ){
                        $parent.find('.js_discount_item').val(data.amount).prop('disabled', true)
                        $parent.find('.js_type_discount_item').val(data.type_discount).prop('disabled', true).trigger('change')

                        if( data.order_reference ){
                            $parent.find('.js_discount_order').val(data.order_reference).prop('disabled', true)
                        }
                    }else if( 'shipping' == typeContent ){
                        $parent.find('.js_price').val(data.price).prop('disabled', true)
                        $parent.find('.js_taxes').val(data.tax_id).prop('disabled', true).trigger('change')
                        if( data.order_reference ){
                            $parent.find('.js_shipping_order').val(data.order_reference).prop('disabled', true)
                            // $parent.find('.js_shipping_unds').val(data.quantity)
                        }
                    }else{
                        // if(false != providerId) {
                        //     $parent.find('.js_price').val(data.price).prop('disabled', true)
                        //     $parent.find('.js_taxes').val(data.tax_id).prop('disabled', true).trigger('change')
                        // } else {
                        //     $parent.find('.js_price').val(data.price).prop('disabled', true)
                        //     $parent.find('.js_taxes').val(data.tax_id).prop('disabled', true).trigger('change')
                        // }
                        if( data.order_reference ){
                            $parent.find('.js_order').val(data.order_reference).prop('disabled', true)
                            $parent.find('.js_unds').val(data.quantity).trigger('change')
                        }

                        $parent.find('.js_price').val(data.price).prop('disabled', true)
                        $parent.find('.js_taxes').val(data.tax_id).prop('disabled', true).trigger('change')
                    }

                    if( data.order_reference ){
                        $parent.find('[data-id-order-sended]').data('id-order-sended', data.order_id)
                    }

                }
            })

            return;
        }

        if('discount' == typeContent ){
            $parent.find('.js_discount_item').prop('disabled', false).val('')
            $parent.find('.js_type_discount_item').prop('disabled', false).val('')
        }else{
            $parent.find('.js_price').prop('disabled', false).val('')
            $parent.find('.js_taxes').prop('disabled', false).val('')
        }
    })
}

// Select2 with user customer and guest
function initSelect2Users(container, selector, tags = false, ajaxUrlDataSelect){
    let $container = $(container)
    let $element = $container.find(selector);
    $element.select2({
        tags: tags,
        ajax: {
            url: ajaxUrlDataSelect, // '/back/ajaxAutocompleteCustomerAndGuest',
            dataType: 'json',
            processResults: function (data) {
                return {
                    results: data
                }
            }
        },
        createTag: function (params) {
            var term = $.trim(params.term)

            if (term === '' || term.indexOf('@') === -1) {
                return null
            }
            return {
                id: term,
                text: term,
                newCustomer: true
            }
        }
    }).on('select2:select', function (e) {
        let selectedValue = $(e.currentTarget).val()
        let $inputName = $container.find('input[name="name"]')
        let $inputSurname = $container.find('input[name="surname"]')

        if( $.isNumeric( selectedValue ) ){
            $.ajax({
                url: '/back/ajaxGetCompleteNameUser',
                data: {
                    'id_user': selectedValue
                },
                success: function(data) {
                    $inputName.val(data.name).prop('disabled', true)
                    $inputSurname.val(data.surname).prop('disabled', true)
                }
            })
        } else {
            $inputName.prop('disabled', false).val('')
            $inputSurname.prop('disabled', false).val('');
        }
    })
}

export{resetSelect2, setProviderId, setOrderId, initBasicSelect2, initSelect2BasicAjax, initSelect2Totals, initSelect2Users};



